<template>
  <div id="ssiAnalysis" class="animated fadeIn h-100">
    <b-row class="h-100">
      <div id="Loader" v-if="LoadYn">
        <div class="spinner-bar">
          <span></span>
          <span></span>
          <span></span>
          <span></span>
        </div>
      </div>
      <b-col style="flex: 0 0 20%; max-width: 20%" class="tree pr20">
        <b-card
          class="h-100 black-border1"
          body-class="h-100 p10"
          header-tag="header"
        >
          <h6 slot="header">차트 조회 옵션</h6>
          <b-form @submit.prevent="getData" class="chartOptions">
            <b-row>
              <b-col>
                <label>프로젝트</label>
                <vue-select
                  class="select-container w200"
                  v-model="search.projectid"
                  :options="search.projectOptions"
                  @input="getStidList"
                  :reduce="(a) => a.value"
                  label="text"
                  :clearable="false"
                  required
                >
                </vue-select>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <label>구조물</label>
                <vue-select
                  class="select-container w200"
                  v-model="search.stid"
                  :options="search.stidOptions"
                  @input="
                    () => {
                      search.dataType = 'file';
                    }
                  "
                  :reduce="(a) => a.value"
                  label="text"
                  :clearable="false"
                  required
                >
                </vue-select>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <label>데이터</label>
                <b-form-select
                  v-model="search.dataType"
                  :options="search.dataTypeOptions"
                  required
                ></b-form-select>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <label>날짜</label>
                <b-form-input
                  type="date"
                  v-model="search.date"
                  :max="search.maxDate"
                  required
                ></b-form-input>
              </b-col>
            </b-row>
            <b-row v-if="search.dataType === 'file'">
              <b-col>
                <label>시간</label>
                <b-form-select
                  v-model="search.selectedTime"
                  :options="search.times"
                  required
                ></b-form-select>
              </b-col>
            </b-row>
            <b-row style="margin-top: 20px">
              <b-col>
                <label>fs(㎐)</label>
                <b-form-input v-model="search.fs" required></b-form-input>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <label>max row</label>
                <b-form-input v-model="search.maxRow" required></b-form-input>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <label>stab. level</label>
                <b-form-input
                  v-model="search.stabLevel"
                  required
                ></b-form-input>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <label>orders</label>
                <b-form-input v-model="search.orders" required></b-form-input>
              </b-col>
            </b-row>
            <b-row style="margin-top: 20px">
              <b-col>
                <label>stab. freq</label>
                <b-form-input v-model="search.stabFreq" required></b-form-input>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <label>damping</label>
                <b-form-input v-model="search.damping" required></b-form-input>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <label>mac</label>
                <b-form-input v-model="search.mac" required></b-form-input>
              </b-col>
            </b-row>
            <b-row style="margin-top: 20px">
              <b-col>
                <label>mode scale</label>
                <b-form-input
                  v-model="search.modeScale"
                  required
                ></b-form-input>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <label>prob thr</label>
                <b-form-input v-model="search.probThr" required></b-form-input>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <label>scaling xi</label>
                <b-form-input
                  v-model="search.scalingXi"
                  required
                ></b-form-input>
              </b-col>
            </b-row>
            <b-row style="margin-top: 20px">
              <b-col>
                <label>scaling mac</label>
                <b-form-input
                  v-model="search.scalingMac"
                  required
                ></b-form-input>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <label>scaling omega_n</label>
                <b-form-input
                  v-model="search.scalingOmegaN"
                  required
                ></b-form-input>
              </b-col>
            </b-row>
            <div class="btnGrp">
              <div class="jcse">
                <b-button
                  class="full-searchBtn"
                  type="submit"
                  :disabled="search.btnDisabled"
                  >분석</b-button
                >
              </div>
            </div>
          </b-form>
        </b-card>
      </b-col>
      <b-col style="flex: 0 0 80%; max-width: 80%" class="cont">
        <b-row class="h-100 chartarea">
          <b-col class="col-12">
            <div class="h62 p15 searchBox mb15 border0">
              <div>
                <label class="pb2">진행상황</label>
                <div class="animated fadeIn prog" v-if="progress.rawfiledown">
                  <i class="fas fa-file-download mr10"></i>RAW FILE
                  다운로드<font
                    v-if="progress.rawfiledownfin"
                    class="ml10"
                    color="#22a75d"
                    ><i class="fas fa-check"></i
                  ></font>
                </div>
                <div class="animated fadeIn prog" v-if="progress.anal">
                  <i class="fas fa-arrow-right"></i>
                </div>
                <div class="animated fadeIn prog" v-if="progress.anal">
                  <i class="fas fa-wave-square mr10"></i>분석
                  <b-spinner
                    v-if="progress.anal && !progress.analfin"
                    class="h20 w20 ml15"
                    label="Loading..."
                  ></b-spinner>
                  <font v-if="progress.analfin" class="ml10" color="#22a75d"
                    ><i class="fas fa-check"></i
                  ></font>
                </div>
              </div>
            </div>
            <b-card
              class="hc-sub77 border0"
              body-class="h-100 p20"
              style="height: calc(100vh - 197px) !important; overflow-y: auto"
            >
              <b-row style="height: 220px">
                <b-col>
                  <b-card
                    class="h-100 default-border1"
                    body-class="h-100 p-0"
                    header-tag="header"
                  >
                    <h6 slot="header">
                      {{ rawChartTitle }}
                    </h6>
                    <div id="rawChart" class="graph"></div>
                  </b-card>
                </b-col>
              </b-row>
              <b-row class="pt10" style="height: 400px">
                <b-row class="w-50 pr10">
                  <b-col>
                    <b-card
                      class="h-100 default-border1"
                      body-class="h-100 p-0"
                      header-tag="header"
                    >
                      <div id="chart" class="graph"></div>
                    </b-card>
                  </b-col>
                </b-row>
                <b-col class="w-50" style="flex-basis: unset">
                  <b-row class="h-85">
                    <b-col>
                      <ag-grid-vue
                        class="ag-theme-balham grid"
                        :gridOptions="gridOptions"
                      ></ag-grid-vue>
                    </b-col>
                  </b-row>
                  <b-row class="h-15">
                    <b-col style="text-align: right">
                      <button
                        class="mode-shape-btn model-shape-type-1"
                        v-on:click="set3dShapeModelType(1)"
                        :disabled="
                          modeShapeDataArray === null ||
                          modeShapeDataArray.length === 0 ||
                          modeShapeDataArray[0] === null ||
                          modeShapeDataArray[0] === undefined
                        "
                      ></button>
                      <button
                        class="mode-shape-btn model-shape-type-2"
                        v-on:click="set3dShapeModelType(2)"
                        :disabled="
                          modeShapeDataArray === null ||
                          modeShapeDataArray.length === 0 ||
                          modeShapeDataArray[1] === null ||
                          modeShapeDataArray[1] === undefined
                        "
                      ></button>
                      <button
                        class="mode-shape-btn model-shape-type-3"
                        v-on:click="set3dShapeModelType(3)"
                        :disabled="
                          modeShapeDataArray === null ||
                          modeShapeDataArray.length === 0 ||
                          modeShapeDataArray[2] === null ||
                          modeShapeDataArray[2] === undefined
                        "
                      ></button>
                    </b-col>
                  </b-row>
                </b-col>
              </b-row>
              <b-row class="pt10" style="height: 250px">
                <b-row class="w-50 pr10">
                  <b-col>
                    <ag-grid-vue
                      class="ag-theme-balham grid"
                      :gridOptions="rsltGridOptions"
                    ></ag-grid-vue>
                  </b-col>
                </b-row>
                <b-row class="w-50">
                  <b-col>
                    <button
                      class="shape-play-btn"
                      v-on:click="start3dShapeAnimate()"
                      :disabled="
                        modeShapeDataArray === null ||
                        modeShapeDataArray.length === 0 ||
                        shapeFrames === null ||
                        shapeFrames.length === 0
                      "
                    >
                      Play
                    </button>
                    <b-card
                      class="h-100 default-border1"
                      body-class="h-100 p-0"
                      header-tag="header"
                    >
                      <div id="chart3dShape" class="graph"></div>
                    </b-card>
                  </b-col>
                </b-row>
              </b-row>
            </b-card>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";
import moment from "moment";
import utils from "../common/utils";
import chartUtil from "../common/chartUtil";
import { AgGridVue } from "ag-grid-vue";
import VueSelect from "vue-select";
import "vue-select/dist/vue-select.css";
var Plotly = require("plotly.js/dist/plotly.min.js");

export default {
  components: {
    AgGridVue,
    VueSelect,
  },
  computed: {
    ...mapGetters([
      "getUserId",
      "getUserAuth",
      "getTreeGridApi",
      "getAlertOptions",
      "getConfirmOptions",
      "getSelectedDataProjectid",
      "getSelectedDataStid",
      "getSelectedDataStartDate",
      "getCenterBus",
      "getWebSocket",
    ]),
  },
  data() {
    return {
      chartConfig: {},
      search: {
        projectid: null,
        projectOptions: [{ value: null, text: "선택" }],
        stid: null,
        stidOptions: [{ value: null, text: "선택" }],
        dataType: null,
        dataTypeOptions: [
          { value: null, text: "선택" },
          { value: "rawe", text: "RAWE" },
          { value: "file", text: "FILE" },
        ],
        date: null,
        maxDate: null,
        times: [],
        selectedTime: null,
        btnDisabled: false,
        fs: 100,
        maxRow: 200,
        stabLevel: 4,
        orders: 50,
        stabFreq: 0.2,
        damping: 0.2,
        mac: 0.3,
        modeScale: 1.0,
        probThr: 1.0,
        scalingXi: 1.0,
        scalingMac: 1.0,
        scalingOmegaN: 1.0,
      },
      rawChartTitle: "RAW",
      rawChart: [],
      chart: {
        clearyn: false,
        data: [],
      },
      chartClicks: 0,
      LoadYn: false,
      progress: {
        rawfiledown: false,
        rawfiledownfin: false,
        anal: false,
        analfin: false,
      },
      subscription: null,
      gridRowData: [],
      gridOptions: {
        columnDefs: null,
        rowData: [],
        localeText: { noRowsToShow: "선택된 데이터가 없습니다." },
        rowSelection: "single",
        toolPanelSuppressSideButtons: true,
        onGridReady: (params) => {
          params.api.sizeColumnsToFit();
        },
        onRowDataChanged: (params) => {
          params.api.sizeColumnsToFit();
        },
        enableSorting: true,
        onRowClicked: (params) => {
          this.modeShapeVector = params.data.modeShapeVector;
          this.getModeShapeData();
        },
        onRowDoubleClicked: (params) => {},
        rowHeight: 35,
        headerHeight: 35,
      },
      rsltGridRowData: [],
      rsltGridOptions: {
        columnDefs: null,
        rowData: [],
        localeText: { noRowsToShow: "선택된 데이터가 없습니다." },
        rowSelection: "single",
        toolPanelSuppressSideButtons: true,
        onGridReady: (params) => {
          params.api.sizeColumnsToFit();
        },
        onRowDataChanged: (params) => {
          params.api.sizeColumnsToFit();
        },
        enableSorting: true,
        onRowClicked: (params) => {},
        onRowDoubleClicked: (params) => {},
        rowHeight: 35,
        headerHeight: 35,
      },
      shapeModelType: 1,
      shapeModeScale: 0,
      modeShapeVector: null,
      modeShapeDataArray: [],
      shapeFrames: [],
      isFirstCall: true,
    };
  },
  created() {
    this.getProjectList();
  },
  beforeMount() {
    this.gridOptions.columnDefs = [
      { headerName: "idx", field: "idx", hide: true },
      { headerName: "Pole Index", field: "ix" },
      { headerName: "fn[㎐]", field: "x" },
      { headerName: "ξ[％]", field: "xi" },
      { headerName: "Mode Shape Vector", field: "modeShapeVector" },
    ];
    this.rsltGridOptions.columnDefs = [
      { headerName: "idx", field: "idx", hide: true },
      { headerName: "f_n [Hz] : MEAN", field: "rslt_0" },
      { headerName: "f_n [Hz] : STD", field: "rslt_1" },
      { headerName: "ξ[%] : MEAN", field: "rslt_2" },
      { headerName: "ξ[%] : STD", field: "rslt_3" },
    ];
    this.search.times = [];
    for (let i = 0; i <= 23; i++) {
      if (i < 10) {
        this.search.times.push("0" + i);
      } else {
        this.search.times.push("" + i);
      }
    }
    this.search.selectedTime = this.search.times[0];
  },
  mounted() {
    this.search.date = moment().add(-1, "day").format("YYYY-MM-DD");
    this.search.maxDate = moment().add(-1, "day").format("YYYY-MM-DD");

    if (this.getSelectedDataStartDate) {
      this.search.date = this.getSelectedDataStartDate;
    }

    this.getCenterBus.$on("webSocketServerMessage", (param) => {
      if (param) {
        switch (param.target) {
          case "rabbitMQData":
            let data = JSON.parse(param.data);
            this.subResourceData(data);
            break;
          case "rabbitMQError":
            this.setAlertTitle();
            this.$bvModal
              .msgBoxOk(param.data, this.getAlertOptions)
              .then((value) => {})
              .catch((err) => {
                console.error(err);
              });
            break;
        }
      }
    });
  },
  methods: {
    ...mapMutations([
      "setAlertTitle",
      "setConfirmTitle",
      "setSelectedDataProjectid",
      "setSelectedDataStid",
      "setSelectedDataStartDate",
    ]),
    getProjectList() {
      var reqBody = {};
      this.$http
        .post("/stat/getProjectListAll", reqBody) // HICC230608 getProjectListAll
        .then((res) => {
          if (res.data.resultyn === "Y") {
            let data = res.data.data;
            let options = [{ value: null, text: "선택" }];
            const projst = {
              PRE: "(준비중)",
              SVC: "",
              IDL: "(휴면)",
              EXP: "(종료)",
            };
            for (let i = 0; i < data.length; i++) {
              options.push({
                value: data[i].projectid,
                text: data[i].projectname + projst[data[i].projstate],
              });
            }
            this.search.projectOptions = options;
            if (this.getSelectedDataProjectid) {
              this.search.projectid = this.getSelectedDataProjectid;
              this.getStidList();
            } else this.search.projectid = null;
          } else {
            this.setAlertTitle("프로젝트 조회 실패");
            this.$bvModal
              .msgBoxOk("관리자에게 문의하세요.", this.getAlertOptions)
              .then((value) => {})
              .catch((err) => {
                console.error(err);
              });
          }
        })
        .catch((err) => {
          console.error(err);
        });
    },
    getStidList() {
      if (!this.search.projectid) {
        this.search.stidOptions = [{ value: null, text: "선택" }];
        this.search.stid = null;
        return;
      }
      var reqBody = {
        projectid: this.search.projectid,
      };
      this.$http
        .post("/sensor/getStidList", reqBody)
        .then((res) => {
          if (res.data.resultyn === "Y") {
            let data = res.data.data;
            let options = [{ value: null, text: "선택" }];
            for (let i = 0; i < data.length; i++) {
              options.push({
                value: data[i].stid,
                text: data[i].stname,
              });
            }
            this.search.stidOptions = options;
            if (this.isFirstCall) {
              if (this.getSelectedDataStid) {
                this.search.stid = this.getSelectedDataStid;
                this.search.dataType = "file";
              } else this.search.stid = null;
            } else this.search.stid = null;
            this.isFirstCall = false;
          } else {
            this.setAlertTitle("구조물 조회 실패");
            this.$bvModal
              .msgBoxOk("관리자에게 문의하세요.", this.getAlertOptions)
              .then((value) => {})
              .catch((err) => {
                console.error(err);
              });
          }
        })
        .catch((err) => {
          console.error(err);
        });
    },
    getData() {
      if (this.search.stid === null && this.search.dataType === null) return;

      var reqBody = {
        stid: this.search.stid,
        datatype: this.search.dataType,
        date: moment(this.search.date).format("YYYYMMDD"),
        time: this.search.selectedTime,
        fs: this.search.fs,
        maxRow: this.search.maxRow,
        stabLevel: this.search.stabLevel,
        orders: this.search.orders,
        stabFreq: this.search.stabFreq,
        damping: this.search.damping,
        mac: this.search.mac,
        modeScale: this.search.modeScale,
        probThr: this.search.probThr,
        scalingXi: this.search.scalingXi,
        scalingMac: this.search.scalingMac,
        scalingOmegaN: this.search.scalingOmegaN,
      };

      this.setSelectedDataProjectid(this.search.projectid);
      this.setSelectedDataStid(this.search.stid);
      this.setSelectedDataStartDate(this.search.date);

      this.search.btnDisabled = true;
      this.LoadYn = true;
      this.initData();

      this.$http
        .post("/ssiAnalysis/getChartData", reqBody, { timeout: 600000 })
        .then((res) => {
          if (res.data.resultyn === "Y") {
            this.shapeModeScale = this.search.modeScale;

            this.getWebSocket.send(
              JSON.stringify({
                target: "onRabbitMQData",
                exchange: "anal_ssi",
                topic: res.data.data.mq_topic_id,
              })
            );
          } else {
            this.search.btnDisabled = false;
            this.LoadYn = false;
            this.setAlertTitle();
            this.$bvModal
              .msgBoxOk("관리자에게 문의하세요.", this.getAlertOptions)
              .then((value) => {})
              .catch((err) => {
                console.error(err);
              });
          }
        })
        .catch((err) => {
          this.search.btnDisabled = false;
          this.LoadYn = false;
          console.error(err);
        });
    },
    initData() {
      this.gridOptions.api.setRowData([]);
      this.gridRowData = [];
      this.rsltGridOptions.api.setRowData([]);
      this.rsltGridOptions.api.setColumnDefs([]);
      this.rsltGridRowData = [];
      this.rsltGridOptions.columnDefs = [];
      this.rawChart = [];
      this.modeShapeDataArray = [];
      this.modeShapeVector = null;
      this.shapeModeScale = 0;

      Plotly.purge("chart");
      Plotly.purge("rawChart");

      this.progress.rawfiledown = false;
      this.progress.rawfiledownfin = false;
      this.progress.anal = false;
      this.progress.analfin = false;
    },
    subResourceData(data) {
      if (data) {
        console.log("Data subscribe!!");
        if (data.state === "ANAL_FIN" || data.state === "FAILED") {
          this.progress.analfin = true;
          this.search.btnDisabled = false;
          this.LoadYn = false;
          this.unSubscriptionData();

          if (data.state === "FAILED") {
            this.setAlertTitle("SSI 분석 실패");
            this.$bvModal
              .msgBoxOk(data.msg, this.getAlertOptions)
              .then((value) => {})
              .catch((err) => {
                console.error(err);
              });
          }
        } else if (data.state === "ANAL_DATA") {
          let chartData = data.msg;
          let scatterData = {
            type: "scatter",
            mode: "markers",
            x: chartData.chart1.x,
            y: chartData.chart1.y,
          };
          let lineData = {
            type: "scatter",
            mode: "lines",
            x: chartData.chart2.x_value,
            y: chartData.chart2.y_value,
          };
          this.chart.data = [scatterData, lineData];
          this.drawDualAxisChart("chart", {
            x1: chartData.chart1.x,
            y1: chartData.chart1.y,
            xi: chartData.chart1.xi,
            ix: chartData.chart1.ix,
            modeShapeVector: chartData.chart1.mode_shape_vector,
            name1: "n",
            text: chartData.chart1.text,
            x2: chartData.chart2.x_value,
            y2: chartData.chart2.y_value,
            name2: chartData.chart2.y_name,
            annotation: {
              xaxis: {
                text: chartData.chart2.x_name,
              },
              yaxis: {
                text: "n",
              },
              yaxis2: {
                text: chartData.chart2.y_name,
              },
            },
          });

          this.rawChartTitle = chartData.chart3.chart_name;
          for (let i = 0; i < chartData.chart3.y.length; i++) {
            let yData = chartData.chart3.y[i];
            this.rawChart.push({
              y: yData.data,
              name: yData.name,
              type: "scatter",
              mode: "lines",
              line: { width: 1 },
            });
          }
          this.drawDefaultChart("rawChart", this.rawChart);

          let ssiAnalRslt = JSON.parse(chartData.ssi_anal_result);
          for (let i = 0; i < ssiAnalRslt.columns.length; i++) {
            let column = ssiAnalRslt.columns[i];

            if (i === 0) {
              this.rsltGridOptions.columnDefs.push({
                headerName: "idx",
                field: "idx",
                hide: true,
              });
            }
            this.rsltGridOptions.columnDefs.push({
              headerName: column,
              field: "rslt_" + i,
            });
          }
          this.rsltGridOptions.api.setColumnDefs(
            this.rsltGridOptions.columnDefs
          );

          for (let i = 0; i < ssiAnalRslt.data.length; i++) {
            let datas = ssiAnalRslt.data[i];

            for (let j = 0; j < datas.length; j++) {
              let data = datas[j];

              if (j === 0) {
                this.rsltGridRowData.push({ idx: j });
              }
              this.rsltGridRowData[this.rsltGridRowData.length - 1][
                "rslt_" + j
              ] = data;
            }
          }
          this.rsltGridOptions.api.setRowData(this.rsltGridRowData);

          // this.modeShapeDataArray = chartData.mode_shape
          // this.set3dShape(1)
        } else {
          switch (data.state) {
            case "DATA_DN_START":
              this.progress.rawfiledown = true;
              break;
            case "DATA_DN_FIN":
              if (!this.progress.rawfiledown) this.progress.rawfiledown = true;
              this.progress.rawfiledownfin = true;
              break;
            case "ANAL_START":
              this.progress.anal = true;
              this.LoadYn = false;
              break;
          }
        }
      }
    },
    getModeShapeData() {
      if (this.modeShapeVector === null || this.modeShapeVector === undefined)
        return;

      var reqBody = {
        modeShapeVector: this.modeShapeVector,
        modeScale: this.shapeModeScale,
      };
      this.modeShapeDataArray = [];
      this.LoadYn = true;
      this.$http
        .post("/ssiAnalysis/getModeShapeData", reqBody, { timeout: 600000 })
        .then((res) => {
          this.LoadYn = false;

          if (res.data.resultyn === "Y") {
            this.modeShapeDataArray = res.data.data;
            this.set3dShape();
          } else {
            this.setAlertTitle();
            this.$bvModal
              .msgBoxOk("관리자에게 문의하세요.", this.getAlertOptions)
              .then((value) => {})
              .catch((err) => {
                console.error(err);
              });
          }
        })
        .catch((err) => {
          this.LoadYn = false;
          console.error(err);
        });
    },
    set3dShapeModelType(type) {
      this.shapeModelType = type;
      this.set3dShape();
    },
    init3dShape() {
      this.shapeFrames = [];
      Plotly.purge("chart3dShape");
    },
    set3dShape() {
      this.init3dShape();
      console.log(this.modeShapeDataArray);
      let divId = "chart3dShape";
      let data = this.modeShapeDataArray.find(
        (x) => x.model_type === this.shapeModelType
      );
      console.log(data);
      if (data) {
        let chart = [
          {
            x: data.node_x,
            y: data.node_y,
            z: data.node_z,
            mode: "lines",
            name: "Original",
            line: {
              width: 10,
              color: "#6881f9",
              opacity: 0.8,
            },
            type: "scatter3d",
          },
          {
            x: data.node_x,
            y: data.node_y,
            z: data.node_z,
            mode: "lines",
            name: "Mode Shape",
            line: {
              width: 10,
              color: "#f96868",
            },
            type: "scatter3d",
          },
          {
            x: data.s_node_x,
            y: data.s_node_y,
            z: data.s_node_z,
            mode: "markers",
            name: "Sensor",
            marker: {
              color: "#b4b7bd",
              size: 8,
              symbol: "circle",
              line: {
                color: "#000",
                width: 1,
              },
              opacity: 0.8,
            },
            type: "scatter3d",
          },
        ];
        this.shapeFrames = [
          { data: [{ x: data.node_x, y: data.node_y, z: data.node_z }] },
          { data: [{ x: data.node_x, y: data.node_y, z: data.node_z11 }] },
          { data: [{ x: data.node_x, y: data.node_y, z: data.node_z1 }] },
          { data: [{ x: data.node_x, y: data.node_y, z: data.node_z11 }] },
          { data: [{ x: data.node_x, y: data.node_y, z: data.node_z }] },
          { data: [{ x: data.node_x, y: data.node_y, z: data.node_z22 }] },
          { data: [{ x: data.node_x, y: data.node_y, z: data.node_z2 }] },
          { data: [{ x: data.node_x, y: data.node_y, z: data.node_z22 }] },
          { data: [{ x: data.node_x, y: data.node_y, z: data.node_z }] },
        ];
        let layout = chartUtil.setDefault3dLayout(divId);
        layout.scene.xaxis.range = [-1, 11];
        layout.scene.yaxis.range = [-1, 2];
        layout.scene.zaxis.range = [-1, 1];

        Plotly.newPlot(divId, chart, layout).then(() => {
          Plotly.addFrames(divId, this.shapeFrames, layout);
        });
      }
    },
    start3dShapeAnimate() {
      let divId = "chart3dShape";
      let layout = chartUtil.setDefault3dLayout(divId);

      Plotly.animate(
        divId,
        this.shapeFrames,
        {
          transition: {
            duration: 500,
            easing: "linear",
            // easing: 'elastic-in'
            // easing: 'cubic-in'
            // easing: 'cubic-in-out'
          },
          frame: {
            duration: 500,
          },
          mode: "next",
          // mode: 'afterall'
        },
        layout
      );
    },
    unSubscriptionData() {
      if (this.subscription != null) {
        this.subscription.unsubscribe();
        this.subscription = null;
      }
    },
    drawDualAxisChart(id, param, range) {
      let markerColors = [];
      let markerSizes = [];
      for (let i = 0; i < param.y1.length; i++) {
        markerSizes.push(8);
        markerColors.push("#bdbdbd");
        param.text[i] = param.text[i].replace(" <br> ", "<br>");
        param.text[i] =
          "f_n = " +
          param.x1[i].toFixed(2) +
          " Hz<br>n = " +
          param.y1[i] +
          "<br>" +
          param.text[i];
      }
      var charData = [
        {
          x: param.x1,
          y: param.y1,
          xi: param.xi,
          ix: param.ix,
          modeShapeVector: param.modeShapeVector,
          text: param.text,
          name: param.name1,
          type: "scatter",
          mode: "markers",
          marker: {
            size: markerSizes,
            color: markerColors,
          },
          hoverinfo: "text",
        },
        {
          x: param.x2,
          y: param.y2,
          name: param.name2,
          type: "scatter",
          mode: "lines",
          yaxis: "y2",
          line: { width: 1 },
        },
      ];
      var layout = chartUtil.setDualAxisLayout(id, {
        datacnt: param.x2.length,
        showxaxiscnt: 4,
        annotation: param.annotation,
      });
      layout.margin = {
        l:
          utils.chkNull(param.annotation) !== null &&
          utils.chkNull(param.annotation.yaxis) !== null
            ? 80
            : 50,
        r:
          utils.chkNull(param.annotation) !== null &&
          utils.chkNull(param.annotation.yaxis2) !== null
            ? 80
            : 50,
        t: 20,
        b: 80,
        pad: 0,
      };
      layout.hovermode = "closest";
      layout.showlegend = false;
      if (utils.chkNull(range) !== null) {
        if (
          utils.chkNull(range.x) !== null &&
          (range.x.min !== 0 || range.x.max !== 0)
        ) {
          layout.xaxis.range = [range.x.min, range.x.max];
        }
        if (
          utils.chkNull(range.y) !== null &&
          (range.y.min !== 0 || range.y.max !== 0)
        ) {
          layout.yaxis.range = [range.y.min, range.y.max];
        }
        if (
          utils.chkNull(range.y2) !== null &&
          (range.y2.min !== 0 || range.y2.max !== 0)
        ) {
          layout.yaxis2.range = [range.y2.min, range.y2.max];
        }
      }
      Plotly.newPlot(id, charData, layout).then((gd) => {
        gd.on("plotly_click", (data) => {
          this.chartClicks++;
          if (this.chartClicks === 1) {
            setTimeout(() => {
              if (this.chartClicks === 1) {
                this.setChartSingleClickEvent(gd, data);
              } else {
                this.setChartDoubleClickEvent(gd, data);
              }
              this.chartClicks = 0;
            }, 300);
          }
        });
      });
    },
    setChartSingleClickEvent(gd, data) {
      let pn = "";
      let tn = "";
      let colors = [];
      let sizes = [];
      let idx;
      let x;
      let xi;
      let ix;
      let modeShapeVector;
      let isSelectedMarker = false;
      for (let i = 0; i < data.points.length; i++) {
        pn = data.points[i].pointNumber;
        tn = data.points[i].curveNumber;
        isSelectedMarker = data.points[i].data.marker !== undefined;

        if (isSelectedMarker) {
          colors = data.points[i].data.marker.color;
          sizes = data.points[i].data.marker.size;
          idx = data.points[i].pointIndex;
          xi = data.points[i].data.xi;
          ix = data.points[i].data.ix;
          modeShapeVector = data.points[i].data.modeShapeVector;
          x = data.points[i].x;
        }
      }

      if (isSelectedMarker) {
        if (colors[pn] === "#ff0000") {
          sizes[pn] = 8;
          colors[pn] = "#bdbdbd";
          let findIdx = this.gridRowData.findIndex((x) => x.idx === idx);

          if (findIdx > -1) {
            this.gridRowData.splice(findIdx, 1);
          }
        } else {
          sizes[pn] = 14;
          colors[pn] = "#ff0000";
          this.gridRowData.push({
            idx: idx,
            ix: ix[pn],
            x: x,
            xi: xi[pn],
            modeShapeVector: modeShapeVector[pn],
          });
        }
        this.gridOptions.api.setRowData(this.gridRowData);
        let update = { marker: { color: colors, size: sizes } };
        Plotly.restyle(gd, update, [tn]);
      }
    },
    setChartDoubleClickEvent(gd, data) {
      let colors = [];
      let sizes = [];
      let isSelectedMarker = false;
      for (let i = 0; i < data.points.length; i++) {
        isSelectedMarker = data.points[i].data.marker !== undefined;

        if (isSelectedMarker) {
          colors = data.points[i].data.marker.color;
          sizes = data.points[i].data.marker.size;
        }
      }

      if (isSelectedMarker) {
        this.gridOptions.api.setRowData([]);
        this.gridRowData = [];

        while (true) {
          let idx = colors.findIndex((x) => x === "#ff0000");

          if (idx > -1) {
            colors[idx] = "#bdbdbd";
            sizes[idx] = 8;
          } else {
            break;
          }
        }
        let update = { marker: { color: colors, size: sizes } };
        Plotly.restyle(gd, update);
      }
    },
    drawDefaultChart(id, dataArr) {
      var data = dataArr;
      var layout = chartUtil.setDefaultLayout(id);

      layout.margin = {
        l: 80,
        r: 50,
        t: 20,
        b: 30,
        pad: 0,
      };
      layout.showlegend = false;
      Plotly.newPlot(id, data, layout);
    },
  },
};
</script>

<style lang="scss">
#ssiAnalysis {
  padding: 15px;
  & .chartOptions {
    height: calc(100vh - 187px);
    overflow-y: auto;
    & .row {
      height: 50px;
      & .col {
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 10px 0;
        & label {
          display: flex;
          align-items: center;
          justify-content: flex-start;
          color: #b4b7bd;
          width: 100px;
          height: 100%;
          margin-bottom: 0;
        }
        & input,
        & select {
          width: 200px;
        }
      }
    }
  }
  & .rawe-progress {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0px;
    left: 0px;
    background-color: rgba(6, 6, 6, 0.3);
    & > div.progress {
      position: relative;
      top: calc(50% - 15px);
      width: 400px;
      height: 30px;
      left: calc(50% - 200px);
    }
  }
  & .searchBox {
    justify-content: space-between;
    border-radius: 5px;
    & > div:first-child {
      & > label {
        display: flex;
        align-items: center;
        height: 100%;
        font-size: 16px;
      }
    }
    & .prog {
      display: flex;
      align-items: center;
      height: 100%;
      color: #fff;
      font-size: 16px;
      margin-right: 20px;
      &:last-child {
        margin-right: 0;
      }
    }
    & .custom-checkbox {
      & > input[type="checkbox"] {
        width: 140px;
      }
      & > label {
        display: flex;
        align-items: center;
        justify-content: center;
        &.custom-control-label {
          &::before,
          &::after {
            top: 7px;
            left: -20px;
          }
        }
      }
    }
  }
  & .chartarea {
    & .card {
      & .card-header {
        padding: 6px 15px 8px;
        border-bottom: 1px solid #404656;
        & h6 {
          font-size: 15px;
          line-height: unset;
          justify-content: center;
        }
      }
      & .card-body {
        & .graph {
          height: 100%;
        }
      }
    }
  }
  & div.ag-theme-balham.grid {
    height: calc(100% - 60px) !important;
    & .ag-root .ag-body .ag-body-viewport {
      overflow-x: hidden;
    }
  }
  & .mode-shape-btn {
    width: 150px;
    height: 100%;
    border: 1px solid;
    border-color: #f1f1f1;
    border-radius: 5px;
    background-color: #ffffff54;
    color: #fff;
  }
  & .mode-shape-btn:hover {
    border-color: #6349f3;
  }
  & .mode-shape-btn:disabled {
    border-color: #1b1b1b;
    background-color: #00000096;
  }
  & .model-shape-type-1 {
    background-image: url("../../../static/img/shapeModelType_1.png");
    background-position: center center;
    background-repeat: no-repeat;
  }
  & .model-shape-type-2 {
    background-image: url("../../../static/img/shapeModelType_2.png");
    background-position: center center;
    background-repeat: no-repeat;
  }
  & .model-shape-type-3 {
    background-image: url("../../../static/img/shapeModelType_3.png");
    background-position: center center;
    background-repeat: no-repeat;
  }
  & .shape-play-btn {
    color: #fff;
    background-color: transparent;
    margin-bottom: 5px;
  }
  & .shape-play-btn:disabled {
    color: #555;
    background-color: #0000003b;
    margin-bottom: 5px;
  }
  .select-container {
    .vs__dropdown-toggle {
      width: 200px;
      height: 35px;
      margin-right: 0px;
    }
    // .vs__search::placeholder {
    //   color: #b4b7bd !important;
    // }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/analysis/SsiAnalysis.vue